import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { PostDto, SessionDto } from '@oracychampions/api-interfaces';

@Injectable({
  providedIn: 'root',
})
export class SessionsService {
  private http = inject(HttpClient);

  refresh$ = new BehaviorSubject(null);
  refreshPosts$ = new BehaviorSubject(null);

  reloadPosts() {
    this.refreshPosts$.next(null);
  }

  getSession(id: string): Observable<SessionDto> {
    return this.http.get<SessionDto>(`${environment.API}/sessions/${id}`);
  }

  getPosts(sessionId: string): Observable<PostDto[]> {
    return this.refreshPosts$.pipe(
      switchMap(() => this.http.get<PostDto[]>(`${environment.API}/sessions/${sessionId}/posts`)),
    );
  }
}
